import { render, staticRenderFns } from "./VipHeader.vue?vue&type=template&id=df3af852&scoped=true&"
import script from "./VipHeader.vue?vue&type=script&lang=ts&"
export * from "./VipHeader.vue?vue&type=script&lang=ts&"
import style0 from "./VipHeader.vue?vue&type=style&index=0&id=df3af852&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df3af852",
  null
  
)

export default component.exports